import useSpecificLocation from '@ubeya/shared/hooks/account/useSpecificLocation';
import React from 'react';
import LocationModal from './LocationModal';

const GeneralLocationModal = ({
  selectedLocation: inputSelectedLocation,
  onClose,
  onConfirm,
  showBranchSelector = false,
  editableAddress = false,
  branchesOptions = [],
  disableFieldsEdit = false,
  className,
  showOrgAssignments = false
}) => {
  const { data: selectedAccountLocation, isLoading: isLoadingSelectedAccountLocation } = useSpecificLocation({
    locationId: inputSelectedLocation.id,
    withAttachments: true
  });

  const isAdd = !inputSelectedLocation.id;
  const selectedLocation = isAdd ? inputSelectedLocation : selectedAccountLocation;

  return (
    <LocationModal
      className={className}
      disableFieldsEdit={disableFieldsEdit}
      selectedLocation={selectedLocation}
      isLoadingSelectedLocation={isLoadingSelectedAccountLocation}
      onClose={onClose}
      onConfirm={onConfirm}
      editableAddress={editableAddress}
      showBranchSelector={showBranchSelector}
      showOrgAssignments={showOrgAssignments}
      branchesOptions={branchesOptions}
    />
  );
};

export default GeneralLocationModal;
